export function VVGarageAddCustomerCtrl ($uibModalInstance, $scope, $translate, workshopAPI, messages, VVGarage) {
  $scope.VVGarage = VVGarage;
  
  $scope.create = function() {
    workshopAPI.post('/vv_garage/add_customer', $scope.VVGarage.vv_garage, 'vv_garage').then(() => {
      $uibModalInstance.close()
    }).catch(data => {
      messages.error(data);
    });
  };
}